import { useState } from 'react';
import { Modal, ModalBody, Button, Stack } from '@7shifts/sous-chef-base';
import type {
    DepartmentSelectionRequiredResponse,
    PunchResponse
} from '@src/api/punchTypes';
import { useTranslation } from '@src/i18n';

interface DepartmentSelectionModalProps {
    response: DepartmentSelectionRequiredResponse;
    onExecute: (execute: () => Promise<PunchResponse>) => void;
}

export function DepartmentSelectionModal({
    response,
    onExecute
}: DepartmentSelectionModalProps) {
    const [submitted, setSubmitted] = useState(false);
    const { t } = useTranslation();

    function handleSelect(departmentId: number) {
        if (submitted) return;
        setSubmitted(true);
        onExecute(() => response.selectDepartment(departmentId));
    }

    return (
        <Modal
            header={t('department.title')}
            testId="department-selection-modal"
        >
            <ModalBody>
                <Stack space={8}>
                    {response.departments.map(department => (
                        <Button
                            key={department.id}
                            type="button"
                            theme="hollow"
                            size="full-width"
                            disabled={submitted}
                            loading={submitted}
                            onClick={() => handleSelect(department.id)}
                            testId={`department-selection-${department.id}`}
                        >
                            {department.name}
                        </Button>
                    ))}
                </Stack>
            </ModalBody>
        </Modal>
    );
}
